import { render } from "./HiddenField.vue?vue&type=template&id=d0dca65c"
import script from "./HiddenField.vue?vue&type=script&lang=js"
export * from "./HiddenField.vue?vue&type=script&lang=js"

import exportComponent from "/www/brandsecurity_2/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HiddenField.vue"]])

export default __exports__